import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgForm, UntypedFormGroup, UntypedFormBuilder, AbstractControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService, PortfolioService } from 'src/app/services';

/**
 * Using custom validation
 * @param min Minimum length of the array
 */

export const minLengthArray = (min: number) => {
  return (c: AbstractControl): {[key: string]: any} => {
    if (c.value.length >= min || c.value.length === 0) {
      return null;
    }
    return { minLengthArray: true};
  };
};


@Component({
    selector: 'app-add-aggregation-modal',
    templateUrl: './add-aggregation-modal.component.html',
    styleUrls: ['./add-aggregation-modal.component.scss'],
    standalone: false
})
export class AddAggregationModalComponent implements OnInit {

  @Input() idExecution: string;
  // tslint:disable-next-line: no-output-native
  @Output() submit = new EventEmitter<boolean>();
  portfoliosName: { name_portfolio: string }[];
  list: { name_portfolio: string }[];
  addAggregationForm: UntypedFormGroup;
  submitted = false;

  constructor(
    private activeModal: NgbActiveModal,
    private portfolioService: PortfolioService,
    private formBuilder: UntypedFormBuilder,
    private toastService: ToastService) { }

  async ngOnInit() {
    this.addAggregationForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      list: [[], [Validators.required, minLengthArray(2)]]
    });
    try {
      this.portfoliosName = (await this.portfolioService.getAvailablePortfoliosForAggregation(this.idExecution)).portfolio_items;
    } catch (error) {
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
  }

  /**
   * Get reactive form
   */

  get addAggregation() { return this.addAggregationForm.controls; }

  /**
   * Get reactive form
   * @param f Form
   */

  async onSubmit(f: NgForm) {
    this.submitted = true;
    if (f.invalid) { return; }
    try {
      const res = await this.portfolioService.createAggregationByPortfolios(this.idExecution, f.value.name, f.value.list);
      this.submit.emit(res.status);
      this.activeModal.close();
    } catch (error) {
      this.toastService.showError(error.error);
      console.error('error =>', error);
    }
  }

  /**
   * Close modal
   */

  onDelete() {
    this.activeModal.close();
  }
}
